<template>
	<!-- 签到首页 -->

    <!-- <van-nav-bar title="参与活动得奖励" /> -->
    <div class="soole-activity">
      <div class="soole-activity-contribution">
        <img src="../../../static/images/contribution.png" alt="">
        <div>
          <span>{{ contrib }}</span>
          <span>贡献值总分</span>
        </div>
      </div>
      <div class="soole-activity-new">
        <img src="../../../static/images/invite.png" @click="nav(2)"/>
        <img src="../../../static/images/monad.png" @click="nav(1)" />
      </div>
      <div class="soole-activity-signIn">
        <img src="../../../static/images/signIn.png" @click="nav(0)" />
      </div>
      <div class="soole-activity-classroom">
        <img src="../../../static/images/classroom.png"  @click="nav(3)"/>
      </div>
    </div>
</template>

<script>
	import { Toast } from 'vant';
	export default {
	  name: "",
	  data() {
	    return {
			userId:'',
			contrib:0,
		};
	  },
	  components:{
	  },
	  created() {
		  this.userId = (this.getParams('userId')).replace(/\//g,'');
		  this.getNum();
	  },
	  mounted() {
	  	 // document.querySelector('body').setAttribute('style', 'background-color:#f8f8f8');
	  	 document.querySelector('body').setAttribute('style', 'background-color:#fff');
	  },
	methods: {
		nav(index){
			switch (index){
				case 0:
					this.$router.push(`/sign?userId=${this.userId}`);
					break;
				case 1:
					this.$router.push(`/newUserOdr?userId=${this.userId}`);
					break;
				case 2:
					this.$router.push(`/userShare?userId=${this.userId}`);
					break;
				case 3:
					this.$router.push(`/article?userId=${this.userId}`);
					break;
				default:
					break;
			}
		},

		async getNum(){
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let params = {userId:this.userId}
			let res = await this.$axios.post(`common/v1/Contrib/getUserSlContrib`,params);
			if(res.data.success){
				Toast.clear();
				console.log('res.data.data',res.data.data);
				this.contrib = res.data.data.contrib;
			}else{
				Toast.clear();
				Toast(res.data.msg);
			}
		},
		/**
		 * 获取页面路径参数值
		 */
		getParams(key) {
			let result = {};
      let paramStr = encodeURI(window.document.location.search);
			if (paramStr) {
				paramStr = paramStr.substring(1);
        let params = paramStr.split('&');
				for (let p = 0; p < params.length; p++) {
					result[params[p].split('=')[0]] = unescape(params[p].split('=')[1]);
				}
			}
			return result[key];
		},
	}
};
</script>

<style lang="less" scoped>
.soole-activity {
  &-contribution {
    height: 10rem;
    width: 100%;
    //background-image: url('../../../static/images/contribution.png');
    //background-repeat: no-repeat;
    //background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    >img{
      position: absolute;
      top: 0;
      left: 0;
      height: 10rem;
      width: 100%;
    }

    >div {
      padding-bottom: 1rem;
      z-index: 9;

      span {
        display: block;
        text-align: center;
      }

      >span:first-child {
        font-size: 2rem;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FFFFFF;
        padding-bottom: 1rem;
      }

      >span:last-child {
        font-size: 1rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
      }
    }
  }

  &-new {
    display: flex;
    justify-content: space-around;

    >img {
      width: 50%;
      height: 11.5rem;
    }
  }

  &-signIn,
  &-classroom {
    display: flex;
    justify-content: center;
    padding: 0.5rem 0 ;
    img {
      width: 22.5rem;
      height: 10rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/integral/index.vue